module.exports = __webpack_public_path__ + "static/media/cbse2011.fa1fb768.jpg";